import { NullValue } from "./../../../ricos-schema/legacy/wix/rich_content/v1/index.js";
const isBoolValue = (val) => typeof val.boolValue === "boolean";
const isStringValue = (val) => typeof val.stringValue === "string";
const isNumberValue = (val) => typeof val.numberValue === "number";
const isArrayValue = (val) => val.listValue !== null && typeof val.listValue === "object" && Array.isArray(val.listValue?.values);
const isStructValue = (val) => val.structValue !== null && typeof val.structValue === "object" && val.structValue?.fields !== null && typeof val.structValue?.fields === "object";
const isNullValue = (val) => val.nullValue === NullValue.NULL_VALUE;
export {
  isArrayValue,
  isBoolValue,
  isNullValue,
  isNumberValue,
  isStringValue,
  isStructValue
};
//# sourceMappingURL=struct-refined-types.js.map
